/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetNotes200ResponseNotesInner
 */
export interface GetNotes200ResponseNotesInner {
    /**
     * The ID of the player
     * @type {string}
     * @memberof GetNotes200ResponseNotesInner
     */
    playerID: string;
    /**
     * The timestamp of the note
     * @type {string}
     * @memberof GetNotes200ResponseNotesInner
     */
    timestamp: string;
    /**
     * The user who added the note
     * @type {string}
     * @memberof GetNotes200ResponseNotesInner
     */
    tracUser: string;
    /**
     * The content of the note
     * @type {string}
     * @memberof GetNotes200ResponseNotesInner
     */
    note: string;
}


/**
 * Check if a given object implements the GetNotes200ResponseNotesInner interface.
 */
export function instanceOfGetNotes200ResponseNotesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "playerID" in value;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "tracUser" in value;
    isInstance = isInstance && "note" in value;
    return isInstance;
}

export function GetNotes200ResponseNotesInnerFromJSON(json: any): GetNotes200ResponseNotesInner {
    return GetNotes200ResponseNotesInnerFromJSONTyped(json, false);
}

export function GetNotes200ResponseNotesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNotes200ResponseNotesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'playerID': json['playerID'],
        'timestamp': json['timestamp'],
        'tracUser': json['tracUser'],
        'note': json['note'],
    };
}

export function GetNotes200ResponseNotesInnerToJSON(value?: GetNotes200ResponseNotesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'playerID': value.playerID,
        'timestamp': value.timestamp,
        'tracUser': value.tracUser,
        'note': value.note,
    };
}

